import styles from "./styles/preset-item.module.scss";

type Props = {
  value: string;
  text: string;
  onClick: (value: string) => void;
  selected: boolean;
};

const PresetItem = ({ value, text, onClick, selected }: Props) => {
  const selectedClassName = selected ? styles.selected : "";

  return (
    <div
      className={styles.preset_item + " " + selectedClassName}
      onClick={() => onClick(value)}
    >
      {text}
    </div>
  );
};

export default PresetItem;
